import styled from "styled-components";
import { baseColors } from "../../../../../../themes/definitions/mrgreen/base-colors";
import {SearchInputAreaMrGreenBox} from "./search-input-area.mrgreen.box";

export const SearchInputAreaMrGreenCisBox = styled(SearchInputAreaMrGreenBox)`
color: ${baseColors.warmWhite};
background: ${props => props.theme.colors.backgroundDark};
border: none;

    border-radius: unset;

    &::placeholder {
        color: ${baseColors.warmWhite};
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        &::placeholder {
            color: ${baseColors.warmWhite};
        }
    }
`;
